"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./BaseExtendedPicker"), exports);
tslib_1.__exportStar(require("./PeoplePicker/ExtendedPeoplePicker"), exports);
tslib_1.__exportStar(require("./examples/PeopleExampleData"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/ExtendedPicker/index.js
// module id = 973
// module chunks = 0